/*
 * @Author: 彭梦婷
 * @Date: 2026-06-29 16:09:06
 * @LastEditors: 彭梦婷
 * @LastEditTime: 2026-07-30 13:42:34
 * @Description: 
 * @FilePath: \company-web-c\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/industry',
    name: 'industry',
    component: () => import(/* webpackChunkName: "industry" */ '../views/BackgroundView.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import(/* webpackChunkName: "service" */ '../views/ServiceView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/aboutus',
    redirect: '/about'
  },
  {
    path: '/ua',
    name: 'ua',
    component: () => import('../views/authorize.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: 'gw',
  routes
})

export default router
